module.exports = __webpack_public_path__ + "static/media/logo-desktop.29fc52fb.svg";